export const CATEGORIES = [
  {
    id: "freni",
    name: "Pastiglie & Dischi Freno",
    desc: "Kit freni ad alte prestazioni per auto e scooter",
    image: "https://images.unsplash.com/photo-1696494561430-de087dd0bd69?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "filtri",
    name: "Filtri Olio, Aria & Abitacolo",
    desc: "Manutenzione ordinaria motore e filtrazione",
    image: "https://images.unsplash.com/photo-1777118947168-b6e806cb80cf?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "frizione_variatore",
    name: "Frizioni, Cinghie & Rulli",
    desc: "Trasmissione scooter SH, Liberty, Beverly e auto",
    image: "https://images.unsplash.com/photo-1563641749712-028dfeab14b3?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "fareria_specchi",
    name: "Fareria, Fanali & Specchietti",
    desc: "Specchietti retrovisori, proiettori LED e frecce",
    image: "https://images.unsplash.com/photo-1687092259627-7792bb0ac9cf?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "batterie_elettrico",
    name: "Batterie & Candele",
    desc: "Batterie AGM/Gel, candele d'accensione e bobine",
    image: "https://images.unsplash.com/photo-1592318348310-f31b61a931c8?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "motore",
    name: "Motore & Blocchi Motore",
    desc: "Blocchi motore, gruppi termici e componenti maggiori",
    image: "https://images.unsplash.com/photo-1563641749712-028dfeab14b3?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "ammortizzatori",
    name: "Ammortizzatori & Sospensioni",
    desc: "Kit sospensioni anteriori e posteriori",
    image: "https://images.unsplash.com/photo-1701836924325-3bdbfc2e8689?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const VEHICLES = [
  "Fiat Panda / 500 / Ypsilon",
  "Volkswagen Polo / Golf",
  "Renault Clio / Captur",
  "Ford Fiesta / Focus",
  "Smart Fortwo / Forfour",
  "Citroën C1 / C3",
  "Peugeot 208 / 308",
  "Toyota Yaris",
  "Honda SH 125",
  "Honda SH 150",
  "Honda SH 350",
  "Sym Twit 125",
  "Sym Twit 150",
  "Piaggio Beverly 300",
  "Piaggio Liberty 50",
  "Piaggio Liberty 125",
  "Piaggio Liberty 150",
  "Piaggio Liberty 200",
];

export const SCOOTER_TAGS = [
  "Honda SH 125",
  "Honda SH 150",
  "Honda SH 350",
  "Sym Twit 125",
  "Sym Twit 150",
  "Piaggio Beverly 300",
  "Piaggio Liberty 50",
  "Piaggio Liberty 125",
  "Piaggio Liberty 150",
  "Piaggio Liberty 200",
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1698533189222-f53e9f4193b9?crop=entropy&cs=srgb&fm=jpg&q=85";
export const WORKSHOP_IMAGE = "https://images.unsplash.com/photo-1625047509248-ec889cbff17f?crop=entropy&cs=srgb&fm=jpg&q=85";
